
define('ldsh!modules/form_editor/templates/preview_custom_email_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(labelVisible) { ;
__p += '\n<label class="control-label col-sm-3" for="" style="display: block;">' +
((__t = ( labelText )) == null ? '' : __t) +
'</label>\n';
 } ;
__p += '\n<div class="col-sm-9 js-control">\n  <input type="email"\n         name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n         placeholder="' +
((__t = ( placeholder )) == null ? '' : __t) +
'"\n         class="form-control js-email"\n         id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n         ' +
((__t = ( isRequired && isAMP ? 'required' : '')) == null ? '' : __t) +
'\n    />\n</div>\n';

}
return __p
};});

